import styled from "styled-components";

const FormWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  .rowContainer {
    display: flex;
    width: 100%;
  }
  .ant-form-item-label {
    padding: 0 !important;
  }
  .ant-form-item {
    margin: 0;
  }
  .seperator {
    width: 40px;
  }
  .signature {
    width: 200px;
    border-bottom: 1px solid gray;
  }
  .bottom_border {
    border-bottom: 1px solid gray;
  }
  .spacerContainer {
    display: flex;
    width: 100%;
    justify-content: space-between;
  }
  .borderedSection {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    width: fit-content;
    padding: 0 10px;
    border: 1px dashed;
    padding-bottom: 5px;
  }
  .underline {
    width: 100%;
    min-width: 100px;
    padding-top: 10px;
    border-bottom: 1px solid gray;
  }
`;

export default FormWrapper;
